<template>
  <el-tabs type="border-card">
    <el-tab-pane label="实际承运人资料">
      <compAdd :parent-data="parentData" />
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import compAdd from "./components/driverAdd.vue";
import { getListDict } from "@/api/commonApi";
export default {
  name: "AddDriverForm",
  components: { compAdd },
  data() {
    return {
      parentData: {
        areaOptions: this.$store.state.components.areaOptions,
        vehicleTypeAllowList: [],
        vehicleClassificationList: [],
        vehicleLengthList: [],
        vehicleWidthList: [],
        vehicleHighList: [],
        vehicleTonnageList: [],
        locationSourceList: [],
        vehicleLicenseColorList: [],
        vehicleEnergyTypeList: []
      }
    };
  },
  created() {
    // 获取数据字典： 准驾车型，车型，车长，车宽，车高，吨位，定位来源，能源类型，颜色
    getListDict({
      types:
        "vehicleTypeAllow,vehicleClassification,vehicleLength,vehicleWidth,vehicleHigh,vehicleTonnage,locationSource,vehicleEnergyType,vehicleLicenseColor"
    }).then(response => {
      this.parentData.vehicleTypeAllowList = response.data.filter(
        item => item.type === "vehicleTypeAllow"
      )[0]["dictList"];
      this.parentData.vehicleClassificationList = response.data.filter(
        item => item.type === "vehicleClassification"
      )[0]["dictList"];
      this.parentData.vehicleLengthList = response.data.filter(
        item => item.type === "vehicleLength"
      )[0]["dictList"];
      this.parentData.vehicleWidthList = response.data.filter(
        item => item.type === "vehicleWidth"
      )[0]["dictList"];
      this.parentData.vehicleHighList = response.data.filter(
        item => item.type === "vehicleHigh"
      )[0]["dictList"];
      this.parentData.vehicleTonnageList = response.data.filter(
        item => item.type === "vehicleTonnage"
      )[0]["dictList"];
      this.parentData.locationSourceList = response.data.filter(
        item => item.type === "locationSource"
      )[0]["dictList"];
      this.parentData.vehicleEnergyTypeList = response.data.filter(
        item => item.type === "vehicleEnergyType"
      )[0]["dictList"];
      this.parentData.vehicleLicenseColorList = response.data.filter(
        item => item.type === "vehicleLicenseColor"
      )[0]["dictList"];
    });
  }
};
</script>
